"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastContainer = exports.StyledToastContainer = exports.ActionLink = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
const theme_1 = __importDefault(require("../styles/theme"));
const styled_div_1 = __importDefault(require("./styled-div"));
const typography_1 = require("../styles/typography");
const icon_1 = __importStar(require("./icon"));
const generalToastStyle = `
  font-family: ${theme_1.default.font.family.sans};
  height: 64px;
  padding-left: 18px;
  cursor: default;
  .Toastify__toast-body {
    padding: 0;
    column-gap: 10px;
  }
  .icon-button {
    margin: auto;
    margin-right: 10px;
  }

`;
exports.ActionLink = styled_components_1.default.button `
  padding: 16px;
  font-weight: 500;
  border: none;
  background-color: transparent;
  font-family: ${theme_1.default.font.family.sans};
  color: ${theme_1.default.colors.textLink};
  cursor: pointer;
`;
exports.StyledToastContainer = styled_components_1.default(react_toastify_1.ToastContainer) `
  .Toastify__toast--error {
    ${typography_1.smallText}
    background: ${(props) => props.theme.colors.backgroundError};
    border-radius: ${(props) => props.theme.borderRadius};
    color: ${(props) => props.theme.colors.textDark};
    ${generalToastStyle}
  }
  .Toastify__toast--success {
    ${typography_1.smallText}
    background: ${(props) => props.theme.colors.backgroundPrimaryAccent};
    border-radius: ${(props) => props.theme.borderRadius};
    color: ${(props) => props.theme.colors.textDark};
    ${generalToastStyle}
  }
  .Toastify__toast--info {
    ${typography_1.smallText}
    background: ${(props) => props.theme.colors.backgroundInfo};
    border-radius: ${(props) => props.theme.borderRadius};
    color: ${(props) => props.theme.colors.textDark};
    ${generalToastStyle}
  }
  .Toastify__toast--warning {
    ${typography_1.smallText}
    background: ${(props) => props.theme.colors.backgroundWarning};
    border-radius: ${(props) => props.theme.borderRadius};
    color: ${(props) => props.theme.colors.textDark};
    ${generalToastStyle}
  }
`;
/**
 *
 * This component provides a way to display quick messages to the user that can stay on screen for a short amount
 * of time before dismissing themselves. In order to use it, place the <ToastContainer /> within the component tree
 * and call the desired function to display the appropriate type of message (for example, showError()).
 *
 * Usage:
 *
 * <ToastContainer autoClose={5000}/>
 * Toast.showError('This is a sample error message', {
 *         actionButtonText: 'Link here',
 *         position: 'top-right',
 *         actionButtonCallback: () => null,
 *       });
 *
 */
const ToastContainer = ({ autoClose = 5000 }) => (react_1.default.createElement(exports.StyledToastContainer, { style: { width: 'fit-content', maxWidth: 952, minWidth: 300, height: 64 }, autoClose: autoClose, closeOnClick: false }));
exports.ToastContainer = ToastContainer;
const toastStyle = {
    position: 'bottom-right',
    hideProgressBar: true,
    closeButton: true,
    style: {
        height: 64,
    },
};
const actionButton = (config) => {
    if (!(config === null || config === void 0 ? void 0 : config.actionButtonText)) {
        return react_1.default.createElement("span", { style: { width: 13, height: 5, display: 'inline-block' } });
    }
    return (react_1.default.createElement(exports.ActionLink, { color: theme_1.default.colors.textLink, onClick: config.actionButtonCallback }, config.actionButtonText));
};
const closeButton = ({ closeToast }) => (react_1.default.createElement(icon_1.IconButton, { name: "close", color: theme_1.default.colors.textDefault, className: "icon-button", onClick: closeToast }));
const commonIconProps = {
    size: '23px',
    style: { pointerEvents: 'none' },
};
exports.default = {
    showError(msg, config) {
        return react_toastify_1.toast.error(react_1.default.createElement(styled_div_1.default, null,
            react_1.default.createElement(styled_div_1.default, null,
                msg,
                " ",
                actionButton(config))), Object.assign(Object.assign({}, toastStyle), { icon: (react_1.default.createElement(icon_1.default, Object.assign({ name: "cancel_rounded_icon", color: theme_1.default.colors.error }, commonIconProps))), position: config ? config.position : 'bottom-right', closeButton }));
    },
    showSuccess(msg, config) {
        return react_toastify_1.toast.success(react_1.default.createElement(styled_div_1.default, null,
            react_1.default.createElement(styled_div_1.default, null,
                msg,
                " ",
                actionButton(config))), Object.assign(Object.assign({}, toastStyle), { position: config ? config.position : 'bottom-right', closeButton, icon: (react_1.default.createElement(icon_1.default, Object.assign({ name: "check_circle_rounded", color: theme_1.default.colors.primaryAccent }, commonIconProps))) }));
    },
    showInformative(msg, config) {
        return react_toastify_1.toast.info(react_1.default.createElement(styled_div_1.default, null,
            react_1.default.createElement(styled_div_1.default, null,
                msg,
                " ",
                actionButton(config))), Object.assign(Object.assign({}, toastStyle), { position: config ? config.position : 'bottom-right', closeButton, icon: (react_1.default.createElement(icon_1.default, Object.assign({ name: "info_rounded", color: theme_1.default.colors.secondaryAccent }, commonIconProps))) }));
    },
    showWarning(msg, config) {
        return react_toastify_1.toast.warn(react_1.default.createElement(styled_div_1.default, null,
            react_1.default.createElement(styled_div_1.default, null,
                msg,
                " ",
                actionButton(config))), Object.assign(Object.assign({}, toastStyle), { position: config ? config.position : 'bottom-right', closeButton, icon: (react_1.default.createElement(icon_1.default, Object.assign({ name: "warning", color: theme_1.default.colors.warning }, commonIconProps))) }));
    },
};
